import React from 'react'
import uniqBy from 'lodash.uniqby'

import List from '../../atoms/List'
import ListItem from '../../atoms/ListItem'
import Icon from '../../atoms/Icon'

// FIXME: excluding font awesome (starting with fab, fal, etc.) and gatedCommunity
const excludedIcons = /fa[bsrpdl] |gatedCommunity/

export default ({ amenities }) => (
  <List inline>
    {uniqBy(amenities, 'icon')
      .filter(amenity => amenity.icon && !amenity.icon.match(excludedIcons))
      .map((amenity, i) => (
        <ListItem key={i}>
          <Icon icon={amenity.icon} size='lg' fixedWidth />
          <span style={{ display: 'none' }}>{amenity.name}</span>
        </ListItem>
      ))}
  </List>
)
